/* jshint esversion: 6 */
/* globals require */
(function (angular) {
    /*
        The purpose of "use strict" is to indicate that the code should be executed in "strict mode".
        With strict mode, you can not, for example, use undeclared variables.
    */
    'use strict';

    const ocLazyLoad = require('oclazyload');
    require('./prototypes');
    const utilsModule = require('@utils/enerveeUtilsModule');

    /**
     * Creates the main angular module of the project and injects ngRoute into it
     */

    angular.module('enervee', [
        ocLazyLoad,
        utilsModule.name,
        'ngSanitize',
        'ngRaven',  // Sentry
        'ngCookies',
        'ui.router',
        'ngMessages',
        'angular.filter',
        'ngAnimate',
        'ngPassword',
        'ui.bootstrap',
        'updateMeta',
        'angulartics',
        'angulartics.google.tagmanager',
        'cloudinary',
        'rzModule',
        'ngFileUpload',
        'slick',
        'chart.js',
        'enervee.a11y',
        'enervee.supportPage',
        'enervee.account',
        'enervee.errorPages',
        'enervee.fastTrack',
    ]);

    require('@app/core/coreModule');

    require('./configs');
    require('./routings');
    require('./filters');
})(angular);
